import { useDockedIncidentComponent } from '@mobile/views/Relation/DetailsPanel/Table/useDockedIncidentComponent'
import { EventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import { IncidentHandlerOptions } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/IncidentHandlersConfiguration'
import { useSportConfiguration } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/useSportConfiguration'

export type AddIncidentWithDockReturnType = {
  addIncidentAndDock: (options: IncidentHandlerOptions) => void
}

/**
 * Adds an incident through its configured handler and, once it appears in
 * history, docks it with the main select opened - the same behaviour used by
 * the VIP incidents section, shared here so any incident-adding flow (VIP
 * incidents, manual add) can reuse it.
 */
export function useAddIncidentWithDock(
  eventInjections: EventInjections,
): AddIncidentWithDockReturnType {
  const { incidentHandlersConfiguration } = useSportConfiguration()
  const { requestVIPIncidentDock } = useDockedIncidentComponent(eventInjections)

  function addIncidentAndDock(options: IncidentHandlerOptions): void {
    const { handler } =
      incidentHandlersConfiguration[options.incidentId] ??
      incidentHandlersConfiguration.fallbackHandler

    handler(options)

    if (options.participantId !== undefined) {
      requestVIPIncidentDock(options.incidentId, options.participantId)
    }
  }

  return { addIncidentAndDock }
}
